import { Reveal } from "@/components/Reveal";

const ROLES = [
  "Traditional Owners & knowledge holders",
  "Ecologists & botanists",
  "Native seed & nursery specialists",
  "Restoration practitioners",
];

export default function Facilitators() {
  return (
    <section className="bg-charcoal text-cream py-28 md:py-40" data-testid="facilitators-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-6">
          <p className="overline text-ochre mb-7">Facilitators & knowledge holders</p>
          <h2 className="font-serif text-4xl md:text-5xl font-light leading-tight">
            Learning shaped by people with deep practical knowledge.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6">
          <p className="text-cream/70 text-lg font-light leading-relaxed">
            The Academy is not built around one teacher. Courses are shaped by experienced
            practitioners, Traditional Owners and specialists who contribute according to the
            subject, region and needs of each program. Where profiles are shared, we emphasise
            experience, relationship to the subject and practical contribution.
          </p>
          <div className="mt-8 flex flex-wrap gap-2">
            {ROLES.map((r) => (
              <span key={r} className="text-xs tracking-wide border border-cream/25 text-cream/80 px-3 py-1.5">{r}</span>
            ))}
          </div>
          <p className="mt-6 text-cream/40 text-xs italic">Facilitator profiles to be added.</p>
        </Reveal>
      </div>
    </section>
  );
}
